"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Tip = _interopRequireDefault(require("./Tip"));

var _Link = _interopRequireDefault(require("./button/Link"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var icons = _interopRequireWildcard(require("../toolkit/icons"));

var illustrations = _interopRequireWildcard(require("../toolkit/illustrations"));

//
//  src/Alert.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 8/7/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
// don't break current imports
var propDoc = {
  text: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "The alert message"
  },
  sentiment: {
    required: true,
    type: "\"positive\" | \"negative\" | \"warning\" | \"info\"",
    description: "Sentiment of the message - determines the color treatment"
  },
  link: {
    required: false,
    defaultValue: "null",
    type: "{ text: string, url: string, onClick: null | undefined | () => void }",
    description: "Set if the alert has a link or callback for button click."
  },
  title: {
    required: false,
    defaultValue: "null",
    type: "string | ((() => ReactNode))",
    description: "Optional title of the alert. Most bolded line"
  },
  iconVerticalAlignment: {
    required: false,
    defaultValue: "center",
    type: "\"top\" | \"center\"",
    description: "Whether to center the icon or top align it"
  }
};
var demoProps = [{
  demoDescription: "positive",
  text: "The penalty was reversed and will be reflected in your future payment invoices.",
  sentiment: "positive",
  link: {
    text: "View policy",
    url: "http://www.google.com"
  }
}, {
  demoDescription: "warning",
  title: "You have 5 days left to fulfill orders.",
  text: "Orders need to be fulfilled within 168 hours " + "from when the order was released. Fulfill orders now.",
  sentiment: "warning"
}, {
  demoDescription: "negative",
  text: "Due to a high refund ratio, your store is not eligible to" + "receive payments from refunded orders.",
  sentiment: "negative",
  link: {
    text: "View policy",
    url: "http://www.google.com"
  }
}, {
  demoDescription: "info",
  text: "You can dispute a Wish Express order within 11 business days" + "from receiving penalty details.",
  sentiment: "info",
  link: {
    text: "View details",
    url: "http://www.google.com"
  }
}];

var Alert = function Alert(props) {
  var styles = useStylesheet();

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      primary = _useTheming$theme.primary,
      positive = _useTheming$theme.positive,
      warning = _useTheming$theme.warning,
      negative = _useTheming$theme.negative;

  var className = props.className,
      style = props.style,
      sentiment = props.sentiment,
      link = props.link,
      title = props.title,
      text = props.text,
      iconVerticalAlignment = props.iconVerticalAlignment;
  var color = primary;

  switch (sentiment) {
    case "positive":
      color = positive;
      break;

    case "warning":
      color = warning;
      break;

    case "negative":
      color = negative;
      break;
  }

  var imageUrl = illustrations.lightBulb;

  switch (sentiment) {
    case "positive":
      imageUrl = icons.cyanCheckmark;
      break;

    case "warning":
      imageUrl = icons.yellowExclamation;
      break;

    case "negative":
      imageUrl = icons.redXSolid;
      break;

    case "info":
      imageUrl = illustrations.lightBulb;
      break;
  }

  var canClick = (link === null || link === void 0 ? void 0 : link.onClick) != null;
  var onClickValue = canClick ? link === null || link === void 0 ? void 0 : link.onClick : null;

  var linkContent = link && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: (0, _styling.css)(styles.link),
    onClick: onClickValue || undefined,
    href: link.url,
    openInNewTab: true
  }, link.text);

  var titleContent = title;

  if (title != null && typeof title === "function") {
    titleContent = title();
  }

  var bodyContent = text;

  if (typeof text === "function") {
    bodyContent = text();
  }

  return /*#__PURE__*/_react["default"].createElement(_Tip["default"], {
    className: (0, _styling.css)(className, style),
    color: color,
    imageUrl: imageUrl,
    iconVerticalAlignment: iconVerticalAlignment
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.textContainer)
  }, titleContent && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.titleText)
  }, titleContent), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.descriptionText)
  }, /*#__PURE__*/_react["default"].createElement("span", null, bodyContent), linkContent)));
};

Alert.propDoc = propDoc;
Alert.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(Alert);

exports["default"] = _default;

var useStylesheet = function useStylesheet() {
  var _useTheming2 = (0, _providers.useTheming)(),
      textBlack = _useTheming2.theme.textBlack,
      fonts = _useTheming2.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      textContainer: {
        alignItems: "flex-start",
        color: textBlack,
        display: "flex",
        flexDirection: "column",
        fontSize: 14,
        justifyContent: "center",
        fontFamily: fonts.regular,
        flex: 1
      },
      descriptionText: {
        fontFamily: fonts.medium,
        alignSelf: "stretch"
      },
      titleText: {
        fontFamily: fonts.bold
      },
      link: {
        marginLeft: 4
      }
    });
  }, [textBlack, fonts.regular, fonts.medium, fonts.bold]);
};